import { MasterDataExtended } from '../api/models';

export class MasterDataContainer {
  static data?: MasterDataExtended;
}
